import React from 'react';

export const IcControlsDropDownUpDownUp = (props) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="ic_controls_drop-down-up_32">
            <path id="Vector 2" d="M16 12L8 20L24 20L16 12Z" fill="#1C1E21" />
        </g>
    </svg>
);
